<template>
  <div class="hello">
        <div  class="head">
      <i @click="goIndex()" v-loading.fullscreen.lock="fullscreenLoading" :size="20" class="el-icon-s-home"></i>
         <img @click="goIndex()"  v-loading.fullscreen.lock="fullscreenLoading" class="logo1" src="../../image/logo1.png" alt="" srcset="">
 
   


<i @click="golist"
    v-loading.fullscreen.lock="fullscreenLoading" class="el-icon-menu"></i>

    </div>



<el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/' }">home</el-breadcrumb-item>
  <el-breadcrumb-item>{{ getData.game_name }}</el-breadcrumb-item>
</el-breadcrumb>


    <div class="gameList">
      <div class="game_itme_url">
        <img :src="getData.game_img" alt="" srcset="" />
        <div style="    display: flex
;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;">
                <h3 class="game_name" style="color: #0d0821;
    text-align: start;
        margin-left: 7px;">{{ getData.game_name }}</h3>

<div class="">
    <i class="el-icon-star-on"></i>
     <i class="el-icon-star-on"></i>
      <i class="el-icon-star-on"></i>
 <i class="el-icon-star-on"></i>
       <i class="el-icon-star-on"></i>
      <span style="font-size:27px; font-weight:600px; color:#ff7800"> 5.0</span> 
</div>

        </div>
  


      </div>

         <el-button @click="scrollToElement" class="go" type="primary">  Get This App</el-button>
  


<div class="ads" ref="ads3"></div>


<div style="     width: 100%;   background: rgb(137, 124, 139);
    padding: 7px;
    border-radius: 12px;
    margin: 10px;
">


<div class="game_list">
  <div class="game_list1">
    <img @click="goDetail(gameList[0])" :src="gameList[0].game_img" alt="" srcset="">
  </div>
   <div class="game_list2">
    <img @click="goDetail(gameList[1])" :src="gameList[1].game_img" alt="" srcset="">
        <img @click="goDetail(gameList[2])" :src="gameList[2].game_img" alt="" srcset="">
  </div>

</div>


<div class="game_list">
  <div class="game_list1">
    <img @click="goDetail(gameList[3])" :src="gameList[3].game_img" alt="" srcset="">
  </div>
   <div class="game_list2">
    <img @click="goDetail(gameList[4])" :src="gameList[4].game_img" alt="" srcset="">
        <img @click="goDetail(gameList[5])" :src="gameList[5].game_img" alt="" srcset="">
  </div>

</div>
</div>
 <div class="desc">
  <h2 style="    text-align: start;">Description</h2> 
  <p class="game_text">{{ getData.game_desc }}</p>
 </div>
      
    </div>


<div  ref="targetElement" style="    padding: 20px;
">
<el-button  type="primary" @click="goPlay" class="play" icon="el-icon-s-promotion"> From Google play</el-button>
</div>




<div class="ads" ref="ads4"></div>

<div style="text-align: start;
    margin-top: 20px;
    font-size: 20px;
    font-weight: 400;
    color: rgb(255 255 255);
    padding: 20px;">
  The tools on the  website come from the Google Play, and then edited on our website. You can download them through the recommended download links. Some tools support infringement, please contact us.
</div>


<div class="bottom-btn">
  <a href="javascript:;" @click="goText('/#/privacy')">Privacy Policy</a>
  <a @click="goText('/#/terms')" href="javascript:;">Terms-of Service</a>
  <a style="border-right:none" href="mailto:asking@asking.media">Contact Us</a>
</div>

  </div>
</template>

<script>
import { getDataList } from "../../data/gameData_19";
export default {
  name: "HelloWorld",
  data() {
    return {
      value: getDataList(),
      getData: null,
      dataId: null,
      gameList:null,
      gameList2:null,
      fullscreenLoading:false
    };
  },
  props: {
    msg: String,
  },

  created() {
    
    window.scrollTo(0, 0);
    this.getData = this.findById(this.$route.query.id)[0];
     this.gameList = this.swiperList(9,this.$route.query.id)
  },
    mounted() {
    // 页面加载完毕后滚动到顶部

   if (localStorage.getItem('Ifgoogl') != 'false') {
  //this.loadAds()
}
  },
  methods: {

    goText(value){
   window.location.href = value
},

goDetail(value){

  window.location.href = `/#/detail?id=${value.id}`
      
},


 loadAds() {
      // 动态插入 Google Ads 代码
      const script = document.createElement('script');
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6372117437285218";
      script.crossorigin = "anonymous"
      script.async = true;
      document.head.appendChild(script);

      // 延迟加载广告
      script.onload = () => {
        this.detailSo()
      };

      this.detailSo = () => {
this.$nextTick(() => {
      // 插入广告元素
      const adDiv3 = this.$refs.ads3;
      adDiv3.innerHTML = `
 <ins class="adsbygoogle"
     style="display:inline-block;width:300px;height:250px"
     data-ad-client="ca-pub-6372117437285218"
     data-ad-slot="3758445512"></ins>
      `;
  // 延迟加载广告
  (window.adsbygoogle = window.adsbygoogle || []).push({});
 })

this.$nextTick(() => {
    // 插入广告元素
      const adDiv4 = this.$refs.ads4;
      adDiv4.innerHTML = `
<ins class="adsbygoogle"
     style="display:inline-block;width:300px;height:250px"
     data-ad-client="ca-pub-6372117437285218"
     data-ad-slot="2044189966"></ins>
      `;
  // 延迟加载广告
  (window.adsbygoogle = window.adsbygoogle || []).push({});
 })
      }

    },

    // 通过id筛选对象
    findById(id) {
      return this.value.filter((obj) => obj.id === id);
    },

 scrollToElement() {
      // 使用 scrollIntoView 来滚动到目标节点
      const target = this.$refs.targetElement;
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',  // 平滑滚动
          block: 'center'       // 对齐方式，可以是 'start', 'center', 'end', 'nearest'
        });
      }
    },
    goPlay(){
       window.location.href = this.getData.game_url;

    },

swiperList(value, excludeId) {
  // 复制原始数据
  var dataCopy = this.value.map(element => element);

  // 如果传入了 excludeId，先过滤掉与之相同的元素
  if (excludeId) {
    dataCopy = dataCopy.filter(item => item.id !== excludeId);
  }

  var arrNew = [];

  // 随机选择指定数量的元素
  for (var i = 0; i < value; i++) {
    if (dataCopy.length === 0) break; // 防止数组为空时继续选择
    var _num = Math.floor(Math.random() * dataCopy.length);
    var mm = dataCopy[_num];
    // 从复制的数组中移除已选择的元素
    dataCopy.splice(_num, 1);
    arrNew.push(mm);
  }

  return arrNew;

  // 后续同步操作可以继续放在这里
},
goIndex(){

 
  // this.$router.replace({path:'/'})
   window.location.href = `/#/`
     
    


},
golist(){
     
   window.location.href = `/#/list`
        
 
  
}
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.head {
    background: #0d0821;
    padding: 20px;
    display: flex;
    min-height: 30px;
    align-items: center;
    justify-content: space-between;
.home{
  width: 12%;
}
.logo1{
       width: 70%;

}
}
.gameList {
  margin: auto;
  padding: 20px;
  /* width: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  .game_itme {
    width: 48%;
    height: 200px;
    margin-bottom: 15px;
  }

  .game_itme_url {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .game_itme_url img {
    border-radius: 24px;
    width: 30%;
    height: 30%;
  }
}
.game_text {
    text-align: start;
    margin-top: 20px;
    font-size: 20px;
    font-weight: 400;
    color: white;
    background: #0d0821;
    padding: 20px;
}


.game_list{
  margin-top: 15px;
width: 100%;
    display: flex;
    justify-content: space-evenly;
}
.game_list1{
  width: 55%;
}
.game_list1 img {
      width: 100%;
      border-radius: 10px;

}
.game_list2{
       width: 27%;
}
.game_list2 img {
      width: 100%;
      border-radius: 10px;

}
.ads{
  width: 100%;
  min-height: 200px;
}

@keyframes pulse {
  0% { transform: scale(1); }
  25% { transform: scale(0.8); }
  50% { transform: scale(1); }
  75% { transform: scale(0.8); }
  100% { transform: scale(1); }
}

.go {
      margin-top: 60px;
    padding: 16px 58px;
    font-size: 1.6rem;
    background: #0d0821;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    animation: pulse 1.5s ease-in-out infinite;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
}
.About{
    margin-top: 15px;
    text-align: start;
    padding: 20px;
    background: #0d0821;
    color: white;
h2{
  text-align: center;
}
}
.bottom-btn{
      background: #0d0821;
    height: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
a{
      color: #fff;
    font-size: 16px;
        text-decoration: none;
    font-weight: 600;
    border-right: 2px solid #fff;
    padding: 4px;
}
.desc{
  margin-top: 20px;
  color: white;
}
.play{
    font-size: 20px;
    width: 100%;
    color: white;
    border-radius: 5px;
    height: 60px;
    background: #8BC34A;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    
}
.el-icon-s-home{
       font-size: 3rem;
    color: #ffffff;
}
.el-icon-menu{
     font-size: 3rem;
  color: #ffffff;
}

@media (max-width: 368px) {
  .game_text {
    font-size: 2vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 2vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 2vw; 
  }
    .el-breadcrumb{
     font-size: 4vw; 
  }
  .el-icon-menu{
    font-size: 4vw; 
  }
  .el-icon-s-home{
     font-size: 4vw;
  }
    /deep/ .el-breadcrumb__separator{
    font-size: 7vw;
  }
}

@media (max-width: 668px) {
  .game_text {
    font-size: 3vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 3vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 3vw; 
  }
    .el-breadcrumb{
     font-size: 3vw; 
  }
    .el-icon-menu{
    font-size: 3vw; 
  }
    .el-icon-s-home{
     font-size: 3vw;
  }
    /deep/ .el-breadcrumb__separator{
    font-size: 7vw;
  }
}


@media (max-width: 768px) {
  .game_text {
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 4vw; 
  }
    .el-breadcrumb{
     font-size: 4vw; 
  }
    .el-icon-menu{
    font-size: 4vw; 
  }
      .el-icon-s-home{
     font-size: 4vw;
  }
    /deep/ .el-breadcrumb__separator{
    font-size: 7vw;
  }
    /deep/ .el-breadcrumb__inner{
     font-size: 7vw;
  }
}


@media (max-width: 900px) {
  .game_text {
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 4vw; 
  }
    .el-breadcrumb{
     font-size: 4vw; 
  }
    .el-icon-menu{
    font-size: 4vw; 
  }
      .el-icon-s-home{
     font-size: 4vw;
  }
    /deep/ .el-breadcrumb__separator{
    font-size: 4vw;
  }
    /deep/ .el-breadcrumb__inner{
     font-size: 4vw;
  }
}


@media (max-width: 1000px) {
  .game_text {
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 4vw; 
  }
  .el-breadcrumb{
     font-size: 2vw; 
  }
    .el-icon-menu{
    font-size: 9vw; 
  }
      .el-icon-s-home{
     font-size: 9vw;
  }
    /deep/ .el-breadcrumb__separator{
    font-size: 4vw;
  }
    /deep/ .el-breadcrumb__inner{
     font-size: 4vw;
  }
}


@media (min-width: 1200px) {

  .game_text {
    font-size: 2vw; /* 在PC端显示时调整文字大小 */
  }

    .game_name{
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
  .play{
    font-size: 2vw; 
  }
    .el-icon-menu{
    font-size: 7vw; 
  }
      .el-icon-s-home{
     font-size: 7vw;
  }
  /deep/ .el-breadcrumb__separator{
    font-size: 3vw;
  }
  /deep/ .el-breadcrumb__inner{
     font-size: 3vw;
  }
  .go{
       font-size: 3vw;
  }
}

.el-icon-star-on{
       font-size: 2.8rem;
  color: #f70d48;
}

.el-breadcrumb{
    margin: 20px;
    background: #0d0821;
    display: flex;
    align-items: center;
    border-radius: 11px;
        font-size: 22px;
    padding: 15px;
}
/deep/ .el-breadcrumb__separator{
  color: #ffffff;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner{
    color: #ffffff !important;
}
/deep/ .el-breadcrumb__inner{
     color: #ffffff !important;
}

</style>
